import { useGroupListFilter, useSetGroupListFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const GroupSearchInput = ({
  onBlur,
  autoFocus,
}: { onBlur?: () => void; autoFocus?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: filter } = useGroupListFilter();
  const { mutateAsync } = useSetGroupListFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('groups.filter.searchPlaceholder')}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  );
};
